import { render, staticRenderFns } from "./company-honors.vue?vue&type=template&id=4563cf7a&scoped=true"
import script from "./company-honors.vue?vue&type=script&lang=js"
export * from "./company-honors.vue?vue&type=script&lang=js"
import style0 from "./company-honors.vue?vue&type=style&index=0&id=4563cf7a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4563cf7a",
  null
  
)

export default component.exports